<script>
    import FormInput from '../../../components/forms/FormInput.vue'
    import SpinnerLoader from '../../../components/loaders/SpinnerLoader.vue'
    import TableBottomActions from './TableBottomActions.vue'
    import { cloneDeep, isEqual } from 'lodash'
    import axios from 'axios'
    import FormModal from '../../../components/modals/FormModal.vue'
    import draggable from 'vuedraggable'

    export default {
        components: {
            FormInput,
            SpinnerLoader,
            TableBottomActions,
            FormModal,
            draggable
        },
        props: {
            checklistItems: {
                type: Array,
                default: [],
                required: true,
            },
            defaultChecklistDeletedItems: {
                type: Array,
                default: [],
                required: true,
            }
        },
        data() {
            return {
                items: [],
                itemsBeforeAnyChanges: [],
                disabledResetButton: true,
                disabledDiscardButton: true,
                disabledSaveButton: true,
                disabledAddButton: false,
                onboardingFormData: {
                    assigneeType: null,
                    id: [],
                    title: [],
                    order: [],
                    isDeleting: []
                },
                isShowAddingNewItemModal: false,
                modalTitle: 'Saving the changes will affect future Tax Companies. Would you like to also apply the changes onto all current Tax Companies?',
                isModalButtonLoading: true,
                saveButtonText: 'Save Changes',
                isTableLoading: true
            }
        },
        computed: {
            // Example admin, sb, tc, tp
            userTypeAbbr() {
                return this.$page.props.auth.user.user_type_abbr;
            },
            // store the original data
            originalChecklistItems() {
                return this.itemsBeforeAnyChanges
            }
        },
        methods: {
            manageFormSubmit() {
                let addedNewItem = false
                this.onboardingFormData.id = []
                this.onboardingFormData.title = []
                this.onboardingFormData.order = []
                this.onboardingFormData.isDeleting = []
                this.items.forEach((element, index, array) => {
                    if(!element.id) {
                        addedNewItem = true
                    }
                    this.onboardingFormData.id.push(element.id)
                    this.onboardingFormData.title.push(element.title)
                    this.onboardingFormData.order.push(element.order)
                    this.onboardingFormData.isDeleting.push(element.isDeleting)
                })
                if(addedNewItem && this.onboardingFormData.assigneeType == null) {
                    this.isShowAddingNewItemModal = true
                    return false
                }
                this.saveButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`
                this.disabledResetButton = this.disabledDiscardButton = this.disabledSaveButton = this.disabledAddButton = true
                axios.post(
                route('sb-onboarding-checklist-items-store'),
                this.onboardingFormData, {
                })
                .then(response => {
                    this.isShowAddingNewItemModal = false
                    this.$inertia.visit(route('sb-onboarding-checklist-items-index'), { method: 'get'})
                    this.items = []
                    this.$toastr.s(response.data.message)
                })
                .catch(err => {
                    this.saveButtonText = `Save Changes`
                    this.disabledResetButton = this.disabledDiscardButton = this.disabledSaveButton = this.disabledAddButton = false
                    this.isShowAddingNewItemModal = false
                    this.onboardingFormData.assigneeType = null,
                    this.isModalButtonLoading = true
                    if(err.response.status == 422) {                  
                        this.items.forEach((element, index, array) => {
                            this.items[index]['idError'] = err.response.data.errors['id.' + index] ? err.response.data.errors['id.' + index][0] : null
                            this.items[index]['orderError'] = err.response.data.errors['order.' + index] ? err.response.data.errors['order.' + index][0] : null
                            this.items[index]['titleError'] = err.response.data.errors['title.' + index] ? err.response.data.errors['title.' + index][0] : null
                            this.items[index]['isDeletingError'] = err.response.data.errors['isDeleting.' + index] ? err.response.data.errors['isDeleting.' + index][0] : null
                        })
                    }
                    if(err.response.status == 400) {
                        this.$toastr.e(err.response.data.message);
                    }
                })
            },
            addItem() {
                this.items.push({
                    id: null,
                    order: 0,
                    title: null,
                    isDeleting: false,
                    idError: null,
                    orderError: null,
                    titleError: null,
                    isDeletingError: null
                })
                this.onboardingFormData.assigneeType = null
                this.isModalButtonLoading = true
                this.manageItemsOrder(null)
            },
            deleteItem(deletingIndex) {
                this.items.forEach((element, index, array) => {
                    if(deletingIndex == index) {
                        if(!element.id) {
                            this.items.splice(deletingIndex, 1)
                        } else {
                            this.items[deletingIndex].isDeleting = !this.items[deletingIndex].isDeleting
                        }
                    }
                })
                this.onboardingFormData.assigneeType = null,
                this.isModalButtonLoading = true
            },
            discardChangesButtonClick() {
                this.$inertia.visit(route('sb-onboarding-checklist-items-index'), { method: 'get'})
            },
            handleAssigneeType(value) {
                this.onboardingFormData.assigneeType = value
                this.isModalButtonLoading = false
            },
            hideAddingNewItemModal() {
                this.isShowAddingNewItemModal = false
                this.onboardingFormData.assigneeType = null
                this.isModalButtonLoading = true
            },
            manageItemsOrder(evt){
                this.items.forEach((item, index) => (item.order = index))
            }
        },
        beforeMount() {
            this.isTableLoading = true
            this.checklistItems.forEach((element, index, array) => {
                this.items.push({
                    id: element.id,
                    order: element.order,
                    title: element.title,
                    isDeleting: false,
                    idError: null,
                    orderError: null,
                    titleError: null,
                    isDeletingError: null
                })
                this.itemsBeforeAnyChanges.push({
                    id: element.id,
                    order: element.order,
                    title: element.title,
                    isDeleting: false,
                    idError: null,
                    orderError: null,
                    titleError: null,
                    isDeletingError: null
                })
                if(index === array.length - 1) {
                    this.isTableLoading = false
                }
            })
            this.disabledResetButton = this.defaultChecklistDeletedItems.length ? false : true
        },
        watch: {
            // by watching the original data
            // create a clone of original data
            // and assign it to the items data variable
            originalChecklistItems() {
                this.items = cloneDeep(this.originalChecklistItems)
            },
            // watch the changes on the items data variable
            items: {
                handler() {
                    // using lodash to compare original data and current data
                    this.disabledDiscardButton = this.disabledSaveButton = isEqual(this.items, this.originalChecklistItems)
                },
                // useful to watch deeply nested properties on a data variable
                deep: true,
            },
        }
    }
</script>

<template>
    <div class="row">
        <div class="table-responsive">
            <table class="table project-list-table table-nowrap table-centered table-borderless align-middle">
                <thead>
                    <tr>
                        <th scope="col" style="width: 20px;">
                            Order
                        </th>
                        <th scope="col">
                            Items
                        </th>
                        <th scope="col" class="text-sm-end">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody v-if="isTableLoading">
                    <tr style="height: 350px;">
                        <td colspan="3">
                            <div class="row d-flex align-items-center justify-content-center">
                                <SpinnerLoader classes="spinner-border text-success" role="status" title="Loading..." />
                            </div>
                        </td>
                    </tr>
                </tbody>
                <draggable v-else v-model="items" tag="tbody" @change="manageItemsOrder">
                    <tr v-for="(item, index) in items" :key="index" :class="item.isDeleting ? 'bg-danger bg-gradient': ''">
                        <td>
                            <ul class="list-inline font-size-20 contact-links mb-0">
                                <li class="list-inline-item px-2">
                                    <a href="javascript: void(0);" title="Drag">
                                        <i class="mdi mdi-drag"></i>
                                    </a>
                                </li>
                            </ul>  
                        </td>
                        <td>
                            <FormInput 
                                title="Enter Item Name" 
                                :showTitle="false" 
                                v-model='item.title' 
                                :error="item.titleError" 
                                type="text"
                                name="title"
                                :isDisabled="item.isDeleting ? true: false"
                            />
                        </td>
                        <td class="text-sm-end">
                            <ul class="list-inline font-size-20 contact-links mb-0">
                                <li class="list-inline-item px-2">
                                    <a 
                                        href="javascript: void(0);"
                                        :title="item.isDeleting ? 'Discard deletion': 'Delete item'"
                                        @click="deleteItem(index)"
                                    >
                                        <i :class="item.isDeleting ? 'fas fa-trash-restore': 'fas fa-trash'"></i>
                                    </a>
                                </li>
                            </ul>                 
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>
        <TableBottomActions 
            v-if="!isTableLoading"
            :addItemClick="addItem"
            :discardChanges="discardChangesButtonClick"
            :saveButtonClick="manageFormSubmit"
            :disabledResetButton="disabledResetButton"
            :disabledDiscardButton="disabledDiscardButton"
            :disabledSaveButton="disabledSaveButton"
            :saveButtonText="saveButtonText"
            :disabledAddButton="disabledAddButton"
        />
        
        <FormModal
            :isShow="isShowAddingNewItemModal"
            :title="modalTitle"
            :isButtonLoading="isModalButtonLoading"
            :isShowSubmitButton="true"
            :isShowCancelButton="true"
            :clickSubmitButton="manageFormSubmit"
            submitButtonText="Save"
            closeButtonText="Cancel"
            @hideModal="hideAddingNewItemModal"
        >
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 p-2">
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                v-model="onboardingFormData.assigneeType"
                                value="all_tc"
                                id="assigneeTypeAllTc"
                                @click="handleAssigneeType('all_tc')"
                            />
                            <label
                                class="form-check-label"
                                for="assigneeTypeAllTc"
                            >
                                Yes, apply changes to current Tax Companies as well
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                v-model="onboardingFormData.assigneeType"
                                value="new_tc"
                                id="assigneeTypeNewTc"
                                @click="handleAssigneeType('new_tc')"
                            />
                            <label
                                class="form-check-label"
                                for="assigneeTypeNewTc"
                            >
                                No, apply changes only to future Tax Companies
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </FormModal>
    </div>
</template>